import { createQuery } from '@tanstack/svelte-query';
import { fetchInputDevices } from '$lib/api/input_device';
import type { InputDeviceResponse } from '$lib/types/input_device';
import { resolveScope, getUnitScope, type ScopeFn } from './scope';

export const inputDevicesQuery = (scope: ScopeFn = getUnitScope()) =>
	createQuery<Array<InputDeviceResponse>>(() => {
		const unitId = resolveScope(scope);
		return {
			queryKey: ['input_devices', { unitId }],
			queryFn: async () => {
				const all = await fetchInputDevices();
				return all.filter((d) => d.unit === unitId);
			},
			enabled: unitId > 0
		};
	});
